import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import Header from "../components/Header";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { Copy } from "lucide-react";

export default function Referrals() {
  const { user } = useAuth();
  const [list, setList] = useState(null);
  const link = user?.referral_code ? `${window.location.origin}/${user.referral_code}` : "";

  useEffect(() => {
    api.get("/referrals")
      .then((r) => setList(r.data))
      .catch((e) => toast.error(formatApiError(e)));
  }, []);

  const copy = async () => {
    await navigator.clipboard.writeText(link);
    toast.success("Link copiado!");
  };

  return (
    <div className="min-h-screen">
      <Header />
      <div className="pt-24 pb-16 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground">Indicações</div>
        <h1 className="font-display text-3xl sm:text-4xl font-bold mt-1">Seus <span className="gold-text">indicados diretos</span></h1>

        <Card className="p-6 mt-6 gold-border">
          <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground">Seu link</div>
          <div className="mt-3 flex items-center gap-2 p-3 rounded-xl bg-muted/60 font-mono text-sm break-all" data-testid="ref-link">
            {link}
          </div>
          <Button className="mt-3 gold-btn hover:opacity-95" onClick={copy} data-testid="ref-copy-btn">
            <Copy className="h-4 w-4 mr-2" /> Copiar link
          </Button>
        </Card>

        <Card className="p-6 mt-6">
          {!list ? (
            <p className="text-sm text-muted-foreground">Carregando...</p>
          ) : list.length === 0 ? (
            <p className="text-sm text-muted-foreground">Você ainda não indicou ninguém. Compartilhe seu link para começar a construir sua rede.</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="text-xs uppercase tracking-wider text-muted-foreground">
                  <tr className="border-b border-border">
                    <th className="text-left py-2">Nome</th>
                    <th className="text-left">Plano</th>
                    <th className="text-left">Status</th>
                    <th className="text-left">Data</th>
                  </tr>
                </thead>
                <tbody data-testid="ref-table">
                  {list.map((r) => (
                    <tr key={r.id} className="border-b border-border/50">
                      <td className="py-2">{r.name}</td>
                      <td><Badge variant="outline">{r.plan_label}</Badge></td>
                      <td>
                        <span className={r.status === "active" ? "text-emerald-500" : "text-rose-500"}>
                          ● {r.status === "active" ? "Ativo" : "Inativo"}
                        </span>
                      </td>
                      <td className="text-muted-foreground">{new Date(r.created_at).toLocaleDateString("pt-BR")}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Card>
      </div>
    </div>
  );
}
